/* AURA HAVEN — hover/touch prefetch (Instant.page-style, ~1 KB)
   On pointer hover or first touch of a same-origin link, prefetch the page HTML
   so the click renders from cache. Skips cart/checkout/account, variant/anchor
   links, mailto/tel, and honours Save-Data / slow connections. */
(() => {
  const probe = document.createElement('link');
  if (!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;
  const c = navigator.connection;
  if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
  const done = new Set();
  const skip = /^(\/cart|\/checkouts?|\/account|\/admin|\/password|\/challenge)/;
  const ok = (a) => {
    if (!a || a.origin !== location.origin) return false;
    if (skip.test(a.pathname) || a.hash || /[?&]variant=/.test(a.search) || /^(mailto|tel|sms):/i.test(a.href)) return false;
    if (a.hasAttribute('download') || a.target === '_blank' || a.dataset.noPrefetch !== undefined) return false;
    return a.pathname + a.search !== location.pathname + location.search;
  };
  const go = (a) => {
    const href = a.pathname + a.search;
    if (done.has(href)) return;
    done.add(href);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    document.head.appendChild(l);
  };
  let t;
  document.addEventListener('mouseover', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!ok(a)) return;
    clearTimeout(t);
    t = setTimeout(() => go(a), 65);
  }, { passive: true });
  document.addEventListener('mouseout', () => clearTimeout(t), { passive: true });
  document.addEventListener('touchstart', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (ok(a)) go(a);
  }, { passive: true });
})();
